import { Component, HostListener, ViewEncapsulation, OnInit, ChangeDetectorRef, inject, signal } from '@angular/core';
import { EnvironmentService } from '../../environment.service';
import { AppUtilityService } from 'src/app/core/services/app-utility/app-utility.service';
import { AARouterURL } from 'src/app/modules/app-routing/enums/routing.enum';
import { MobileNavigationEvent, AARouteEvents } from 'src/app/core/events/events';
import { IMobileNavigationEventModel } from 'src/app/core/models/models';
import { AppRouterDataService } from 'src/app/modules/app-routing/services/app-router-data/app-router-data.service';
import { NativeEventsService } from 'src/app/modules/aa-core/services/native-events/native-events.service';
import { AppService } from 'src/app/modules/aa-core/services/app-service/app.service';
import { FeatureFlagService } from 'src/app/shared/services/feature-flag.service';
import { delay, take, tap } from 'rxjs/operators';
import { UnleashFlags } from 'src/app/core/models/constants';
import { GoogleTagService } from 'src/app/modules/aa-core/services/gpt.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class AppComponent implements OnInit {
  title = 'routeplanner';
  showBanner = false;
  isAlternateAdLoading = false;
  isBetaFeatures = false;
  openInterstitialAd = signal(false);
  private readonly googleTagService = inject(GoogleTagService);

  public showOnMobileDirectionOnly: boolean;

  constructor(
    private readonly envService: EnvironmentService,
    private nativeEventsService: NativeEventsService,
    public cdr: ChangeDetectorRef,
    private appUtilityService: AppUtilityService,
    private appRouteDataService: AppRouterDataService,
    private readonly appService: AppService,
    private readonly featureFlagService: FeatureFlagService
  ) {}

  ngOnInit() {
    this.featureFlagService.startUnleash();
    setTimeout(() => {
      // setTimeout is for sitecore service to wait for unleash
      this.showBanner = sessionStorage.getItem('banner_closed') !== 'true';
    }, 0);
    if (this.envService.routeModel.enableDebug) {
      console.log('Debug mode is enabled');
    }

    this.appRouteDataService.on(MobileNavigationEvent.MOBILE_MENU, this.onMobileMenuEventHandler); // on switching mobile tab
    this.appRouteDataService.on(AARouteEvents.ROUTE_READY, this.onMobileMenuEventHandler); // onload

    this.appUtilityService.windowResizeEmitter$.subscribe((data: any) => {
      this.onMobileMenuEventHandler({ path: this.appRouteDataService.activeRouteTap });
    });
    this.appService.setOneTrustScript();
    this.featureFlagService.onUpdate(() => {
      const flagStatus = this.featureFlagService.isFeatureEnabled(UnleashFlags.AlternateAdLoading);
      if (flagStatus !== this.isAlternateAdLoading) {
        this.isAlternateAdLoading = flagStatus;
      }
      
      const betaflagStatus = this.featureFlagService.isFeatureEnabled(UnleashFlags.betaFeatures);
      if (betaflagStatus !== this.isBetaFeatures) {
        this.isBetaFeatures = betaflagStatus;
      }

      if (!this.isAlternateAdLoading) {
        this.appService
          .waitForConsentOnce$()
          .pipe(
            tap(() => {
              this.appService.setGoogleAdTagScript();
            }),
            delay(100)
          )
          .subscribe(() => {
            this.appService.enableGoogleAdService();
          });
      }

      const interstitialAdStatus = this.featureFlagService.isFeatureEnabled(UnleashFlags.InterstitialAd);
      if (interstitialAdStatus) {
        this.googleTagService.triggerInterstitialAd$.pipe(delay(1000 * 20), take(1)).subscribe(() => {
          if (sessionStorage.getItem('InterstitialAd_Opened') !== 'true') {
            this.openInterstitialAd.set(true);
            sessionStorage.setItem('InterstitialAd_Opened', 'true');
          }
        });
      }  
    });
  }

  private readonly onMobileMenuEventHandler = (event: IMobileNavigationEventModel | any) => {
    if (event.ActivePage === AARouterURL.ROUTE_PLANNER && event.ActiveTab === AARouterURL.ROUTE_PLANNER) {
      this.showOnMobileDirectionOnly = true;
    } else {
      this.showOnMobileDirectionOnly = false;
    }

    if (event.path === AARouterURL.ROUTE_PLANNER && this.appUtilityService.isMobile) {
      this.showOnMobileDirectionOnly = true;
    }

    /**
     * Added the change detection for navigation to map tab
     */
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 10);
  };

  /**
   * [window:resize $event]
   * Emits the event when browser is resize
   */
  @HostListener('window:resize', ['$event']) onResize(event) {
    this.appUtilityService.windowResizeEmitter.next(event);
  }

  /**
   * [onMessageReceived description]
   * This function is used for receiving the post message from index main file
   */
  @HostListener('window:message', ['$event'])
  onMessageReceived(event: any) {
    if (event.data.action === 'mapScriptLoaded') {
      console.log(' === Google Map Script loaded sucessfully...!!!', event.data);
    }
  }
}
